import $ from 'jquery'
import _ from 'underscore'
import React from 'react'
import ReactDOM from 'react-dom'
import IntialData from '../../utility/getTemplateData'
import PayPalUrl from '../../components/payPalUrl'
import AppActions from '../../actions/AppActions'
import { localsMessages } from '../../utility/getTemplateData'

const landingMessages = localsMessages('errors/landingerror') || {}

const LandingErrorPage = React.createClass({

    componentDidMount() {
        AppActions.updateCurrentPage({currentPage: 'landingError'});
		    $('.spinneroverlay').hide();
    },

    handleReturn (){

        const linkpaypal = landingMessages.link && landingMessages.link.paypal || ''
        const returnurl = this.props.returnurl || linkpaypal

        window.location.href = linkpaypal;
    },

    render() {
        const labelpaypal = landingMessages.label && landingMessages.label.paypal || ''
        const sessionexpired = landingMessages.error && landingMessages.error.sessionexpired || ''
        const startnewsession = landingMessages.error && landingMessages.error.startnewsession || ''

        return (
            <div className="donate_wrapper">
                <div className="container">
              		<div className="col-xs-12 col-sm-12 col-md-12 text-center">
                        <div className="error_page_landing">
                            <h1 className="text-center"><span className="icon icon-large icon-attention-large" aria-hidden="true"></span></h1>
                            <p className="error_message1">{sessionexpired}</p>
                            <h5 className="error_message2">{startnewsession}</h5>
                            <div className="col-xs-12 col-sm-12 col-md-12 text-center pp_next_btn_wrapper">
                                <a className="btn btn-danger " onClick={this.handleReturn}>{labelpaypal}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
})

ReactDOM.render(
    <LandingErrorPage />,
    document.getElementById('donateWrapper')
);



// WEBPACK FOOTER //
// ./pages/error/landingerror.js